module.exports = __webpack_public_path__ + "img/pic_number_10_black.d980574f.png";